import { createSelector } from '@reduxjs/toolkit';

import { selectAdjustmentSettings } from '../orderSelectors.ts';
import { getCommentaryTableHelperText } from '../utils/getCommentaryTableHelperText.ts';

export const selectMarketAdjustmentsCommentaryHelperText = createSelector(
  [selectAdjustmentSettings],
  (adjustmentSettings) => {
    return getCommentaryTableHelperText(adjustmentSettings, 'dateOfSale');
  },
);
